import * as React from "react"
import { useEffect } from "react"
import { Autocomplete, TextField } from "@mui/material"
import { getSubmit } from "@ui-seeker/utils"

import { BACKEND_APIS } from "@constants"
import { customerOptions, selectedCustomer } from "../@signals"


/**
 * The customer. Single-select and required — nothing loads without it.
 *
 * Not a convenience: DIPI_LAST_ITEM_RAW keys on (product_id, id_site,
 * id_customer), so a query without a customer returns the same product once per
 * customer and every coverage percentage counts it several times.
 */
export default function ScrapingDataReviewCustomerFilter() {
    useEffect(() => {
        getSubmit(`${BACKEND_APIS.SCRAPING_DATA_REVIEW}/customers`)
            .then(res => { if (res) customerOptions.value = res })
            .catch(err => console.error('Error fetching customers:', err))
    }, [])

    return <Autocomplete
        size="small"
        options={customerOptions.value}
        value={selectedCustomer.value}
        onChange={(_event, newValue) => selectedCustomer.value = newValue}
        isOptionEqualToValue={(option, value) => option.value === value?.value}
        renderInput={(params) => <TextField
            {...params}
            label="Customer *"
            placeholder="Required"
            error={selectedCustomer.value == null}
        />}
    />
}
